/******************************************************************************

CellDL Model Viewer

Copyright (c) 2022 - 2025 David Brooks

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

******************************************************************************/

import SvgViewer from './components/ViewerComponent'
import type { SvgViewerProps, ViewerEvent } from './components/WrappedViewer.vue'

//==============================================================================

export type Theme = 'light' | 'dark' | 'system';

//==============================================================================

export { SvgViewer }
export default SvgViewer

export type AnnotationValue = string|number|boolean|object
export type Annotation = Record<string, AnnotationValue>

export type Annotations = Record<string, Annotation>

export type SvgViewerOptions = {
    tooltip?: string
}

export type { SvgViewerProps, ViewerEvent }

//==============================================================================
//==============================================================================
